import { render, staticRenderFns } from "./Atlas.vue?vue&type=template&id=23be46c8&scoped=true&"
import script from "./Atlas.vue?vue&type=script&lang=js&"
export * from "./Atlas.vue?vue&type=script&lang=js&"
import style0 from "./Atlas.vue?vue&type=style&index=0&id=23be46c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23be46c8",
  null
  
)

export default component.exports